export default __webpack_public_path__ + "70ddc8d6c6d1b8c5326436e9e21c1730.png";